import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getPostAuthRedirectPath } from "lib/authRedirect";
import { isAuthenticated } from "routes/auth";

export default function GuestRoute() {
  const location = useLocation();

  if (isAuthenticated()) {
    return (
      <Navigate
        to={getPostAuthRedirectPath(location.state?.from)}
        replace
      />
    );
  }

  return <Outlet />;
}
